import { api } from '@/lib/api'

import { AccountDetails } from '../types'

export function getAccountDetails({ id }: { id: string }) {
  return api.get<AccountDetails>(`/v1/me/bank-accounts/wallet/${id}`)
}
